import script from "./object_dayCollectionLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./object_dayCollectionLocation.vue?vue&type=script&setup=true&lang=js"

import "./object_dayCollectionLocation.vue?vue&type=style&index=0&id=318f5d86&lang=css&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318f5d86"]])

export default __exports__